import { NamedComplexEnum } from '../../../utils/complexEnum/NamedComplexEnum'
import { resolveValueOrArray } from '../../../utils/resolveValueOrArray'
import {
  Text,
  Date as DateInstance,
  Number,
  Entity,
  Report,
  List,
  Boolean,
} from './instances'

type CustomFieldDataTypeItem =
  | typeof Text
  | typeof DateInstance
  | typeof Number
  | typeof Entity
  | typeof Report
  | typeof List
  | typeof Boolean
type ID = CustomFieldDataTypeItem['id']
type Name = CustomFieldDataTypeItem['name']
class CustomFieldDataTypeEnum extends NamedComplexEnum<
  'CustomFieldDataType',
  CustomFieldDataTypeItem,
  Name,
  ID
> {
  readonly typename = 'CustomFieldDataType'
  Text = Text
  Date = DateInstance
  Number = Number
  Entity = Entity
  Report = Report
  List = List
  Boolean = Boolean
  get values() {
    return [
      this.Text,
      this.Date,
      this.Number,
      this.Entity,
      this.Report,
      this.List,
      this.Boolean,
    ]
  }
  valueIsValid(dataTypeId: string, value: unknown) {
    if (value === null) return true
    if (value === undefined) throw new Error('value cannot be undefined')
    const values: unknown[] = resolveValueOrArray(value)
    return values.every((value) => {
      if (typeof value === 'string') return dataTypeId === this.Text.id
      else if (typeof value === 'number') return dataTypeId === this.Number.id
      else if (typeof value === 'boolean') return dataTypeId === this.Boolean.id
      else if (value instanceof Date) return dataTypeId === this.Date.id
      const complex = Object(value)
      if (!complex.type)
        throw new Error('complex values must have a type property')
      if (
        [
          'ListCustomFieldValue',
          'BooleanListCustomFieldValue',
          'ReportCustomFieldValue',
          'EntityCustomFieldValue',
        ].includes(complex.type)
      )
        return true
      return false
    })
  }
  /**
   * checks whether the supplied {@link dataTypeId} is associated with a
   * {@link CustomFieldDataType}  which uses metadata
   *
   * @see CustomFieldMetadataJSON
   *
   * @param dataTypeId
   */
  usesMetadata(dataTypeId: string) {
    return [this.List, this.Report, this.Entity, this.Date].some(
      ({ id }) => id === dataTypeId
    )
  }
}

export const CustomFieldDataType = new CustomFieldDataTypeEnum()
